import { CALL_API } from "../api.middleware";
import {
  GET_PROFILE_DATA,
  GET_PROFILE_DATA_SUCCESS,
  GET_PROFILE_DATA_FAILED,
} from "../types/profile";
export const KARVY_STOCK_BROKING_LIMITED = "Karvy Stock Broking Limited";
export const SAMCO_STOCK = "SAMCO SECURITIES LIMITED";

export const getProfileData = (params) => async (dispatch) => {
  try {
    await dispatch({
      [CALL_API]: {
        url: "/GetDistributorDetails",
        params,
        method: "GET",
        types: [
          GET_PROFILE_DATA,
          GET_PROFILE_DATA_SUCCESS,
          GET_PROFILE_DATA_FAILED,
        ],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const resetPassword = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/GetChangePassword",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    console.log(`${error}`);
  }
};
